import _ from 'lodash'

const worldPartners2026 = [
    {
        "id": "RXhoaWJpdG9yXzIzODA4MDQ=",
        "name": "QUO",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/e78a6bd0f5c440889388c5057bf38508.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2NA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MDU=",
        "name": "Minor Hotels",
        "logoUrl": "https://static.swapcard.com/public/images/d3d38e9a405f40789edd1bcbd6c6ec33.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2NA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MDY=",
        "name": "Knight Frank",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/97feda61a94243d0a0fd429d35d0a94f.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2NA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MDc=",
        "name": "Rove Hotels",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/d2c1487560c3423fb490d96cb471da87.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2Mw==",
                "value": "exhibitor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Exhibitor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MDg=",
        "name": "Rotana Hotels and Resorts",
        "logoUrl": "https://static.swapcard.com/public/images/793f950867064ec09c696375f4a14cad.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2Nw==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MDk=",
        "name": "Radisson Hotel Group",
        "logoUrl": "https://static.swapcard.com/public/images/61cbc9d9864c4a4f92a07cda247fa600.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2Ng==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MTA=",
        "name": "Aleph Hospitality",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/997d458c00fb4e458857a94e384ff447.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2NA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MTE=",
        "name": "Taiba Investments",
        "logoUrl": "https://static.swapcard.com/public/images/221cb120930442dbb6a698b468e6780c.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2Ng==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MTI=",
        "name": "Club Med",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/20184dd0a58a43efa904436e2e309e81.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2Nw==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MTM=",
        "name": "Accor",
        "logoUrl": "https://static.swapcard.com/public/images/78f057bfb9994a94b560d559c8ac69fc.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2NA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MTQ=",
        "name": "BWH Hotels",
        "logoUrl": "https://static.swapcard.com/public/images/7928866a5cc742928c50f9c3d258cd6b.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2NA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MTU=",
        "name": "The Ascott Limited",
        "logoUrl": "https://static.swapcard.com/public/images/49db52177b8245e79b9aea84cabdf605.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2Nw==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MTY=",
        "name": "Red Sea Global",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/5715dc5ef8a2467e96f2ff49e1ab4a13.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2Nw==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MTc=",
        "name": "STR",
        "logoUrl": "https://static.swapcard.com/public/images/c8e6f43b323543e686ca58d2e569d73f.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2NA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MTg=",
        "name": "Italia Hospitality",
        "logoUrl": "https://static.swapcard.com/public/images/a90452d09a6b49998671a333722cc3c7.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2OA==",
                "value": "country-pavilion",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Country Pavilion"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MTk=",
        "name": "ARADA",
        "logoUrl": "https://static.swapcard.com/public/images/270ad7d66f8049c0b76165ace2af4806.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2Nw==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MjA=",
        "name": "TUI Hotels and Resorts",
        "logoUrl": "https://static.swapcard.com/public/images/ca1c29ad521c424ab5c78c6bd930b175.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2NA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MjE=",
        "name": "The First Group Hospitality",
        "logoUrl": "https://static.swapcard.com/public/images/117faf988f1045edbbe75044b9cba8cd.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2NA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MjI=",
        "name": "United Hospitality Management",
        "logoUrl": "https://static.swapcard.com/public/images/377dfc65e9e245ed81e4c87952a347fe.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2NA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MjM=",
        "name": "Cavendish Maxwell",
        "logoUrl": "https://static.swapcard.com/public/images/4078f6d3e19a442abe5f60954c0ed43f.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2Mw==",
                "value": "exhibitor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Exhibitor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MjQ=",
        "name": "IHG",
        "logoUrl": "https://static.swapcard.com/public/images/2907870e16754212a31705a6ba9abfee.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2Nw==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MjU=",
        "name": "DigiValet",
        "logoUrl": "https://static.swapcard.com/public/images/b733a9ca6e1f46a98760000e175a812a.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2OQ==",
                "value": "brf-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "BRF Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA4MjY=",
        "name": "FSK & Partners",
        "logoUrl": "https://static.swapcard.com/public/images/df8aada28c4949b8a4c9eb7b063df8a0.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2Mw==",
                "value": "exhibitor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Exhibitor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODE3Njk=",
        "name": "The Indian Hotels Company Limited",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/57a3cd54a7b04558baf5aa653c5a1cb2.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2NA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzOTI3MTI=",
        "name": "Start Reverse",
        "logoUrl": "https://static.swapcard.com/public/images/16b033eec74841fc937bea7d633f0f0b.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2Mw==",
                "value": "exhibitor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Exhibitor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzOTI3MTQ=",
        "name": "China - Chongqing District Pavilion",
        "logoUrl": "https://static.swapcard.com/public/images/3d5bb33b2850470fb840297617701e21.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2Ng==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzOTI3MTU=",
        "name": "Global Branded Residences",
        "logoUrl": "https://static.swapcard.com/public/images/5543d6bafd054bd897f38e481f762b6b.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2OQ==",
                "value": "brf-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "BRF Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzOTI3MTY=",
        "name": "Modon Hospitality",
        "logoUrl": "https://static.swapcard.com/public/images/5705f1cec2014db4b3cf78b7dc0f8166.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2Nw==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzOTQ2MzY=",
        "name": "Rikas Hospitality Group",
        "logoUrl": "https://static.swapcard.com/public/images/3d998ff5fcaf4bce8e2ea4855515261c.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2NA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzOTU2ODM=",
        "name": "KOFISI",
        "logoUrl": "https://static.swapcard.com/public/images/2daed3bd72094f7797c8fea0652d2e9d.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2NA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzOTU2ODU=",
        "name": "Legacy Hotels Holding",
        "logoUrl": "https://static.swapcard.com/public/images/88b3bbe7860f4ef4b6b1cdb2d6e97c20.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2NA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzOTU2ODY=",
        "name": "iReserved",
        "logoUrl": "https://static.swapcard.com/public/images/d62631ad9cfd4fbdac901340f753c7d3.png",
        "fields": []
    },
    {
        "id": "RXhoaWJpdG9yXzIzOTU2OTA=",
        "name": "BeCause",
        "logoUrl": "https://static.swapcard.com/public/images/c2d904f3dc6b4044818c5128cfeb937b.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2Mw==",
                "value": "exhibitor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Exhibitor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzOTcwMzg=",
        "name": "H World International",
        "logoUrl": "https://static.swapcard.com/public/images/f28dd330a81d4b7cb5bfbb882cefab17.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2NA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MDQyMTE=",
        "name": "Abu Dhabi Hospitality Academy - Les Roches",
        "logoUrl": "https://static.swapcard.com/public/images/77f3f18c5c394655a1f5826132875458.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTM0Mzg2NA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzg1NTI0Ng==",
                    "name": "Sponsor Type"
                },
                "translations": [
                    {
                        "value": "Sponsor"
                    }
                ]
            }
        ]
    }
]

const saudiPartners2026 = [
    {
        "id": "RXhoaWJpdG9yXzIyMzQ1NjU=",
        "name": "Al Khozama",
        "logoUrl": "https://static.swapcard.com/public/images/0aa02626bb114944bcc368c78279d2c6.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQxNw==",
                "value": "host-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Host Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMzQ1Njc=",
        "name": "BWH Hotels",
        "logoUrl": "https://static.swapcard.com/public/images/41baf781353e49979ce09d0cef50100f.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQ0MQ==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMzQ1Njg=",
        "name": "Aleph Hospitality",
        "logoUrl": "https://static.swapcard.com/public/images/f0b699e3707e4ed6babef63d88d31cb9.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMQ==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMzQ1Njk=",
        "name": "Amsa Hospitality",
        "logoUrl": "https://static.swapcard.com/public/images/c729b498798d4e00ad3646408808e42c.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQ0Mg==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMzQ1NzI=",
        "name": "Knight Frank",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/97feda61a94243d0a0fd429d35d0a94f.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMQ==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMzQ1NzM=",
        "name": "Red Sea Global",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/840416ae058446069c9e02d645798d66.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQ0Mg==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMzQ1NzQ=",
        "name": "QUO",
        "logoUrl": "https://cdn-api.swapcard.com/public/images/e78a6bd0f5c440889388c5057bf38508.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMQ==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMzQ1NzU=",
        "name": "Legacy Hotels Holding",
        "logoUrl": "https://static.swapcard.com/public/images/c86563a37fd14426b28d5335995c3c3b.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMQ==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMzQ1NzY=",
        "name": "Taiba Investments",
        "logoUrl": "https://static.swapcard.com/public/images/0ca46de05cea47578606575f3c276f4a.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQ0Mw==",
                "value": "founding-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Founding Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMzQ1Nzc=",
        "name": "Sophos Hotels",
        "logoUrl": "https://static.swapcard.com/public/images/da47d2dbf21d42828456c4f4c78f8b0d.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMg==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMzQ1Nzg=",
        "name": "Shaza Hotels",
        "logoUrl": "https://static.swapcard.com/public/images/be86957ee5a349d89eb2f22761541f99.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMg==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMzQ1ODA=",
        "name": "Mandarin Oriental Al Faisaliah, Riyadh",
        "logoUrl": "https://static.swapcard.com/public/images/7991f72f3ba642a0aa98313fd616fee8.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQxNw==",
                "value": "host-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Host Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMzg1NDY=",
        "name": "Rove Hotels",
        "logoUrl": "https://static.swapcard.com/public/images/afb86eb3c8e8401695a2b646f4060cfd.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMg==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMzg1NDg=",
        "name": "JT + Partners Architects and Planners",
        "logoUrl": "https://static.swapcard.com/public/images/64ec6824a5344d608887ef4aeba13ce8.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMQ==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMzg1NDk=",
        "name": "Melia Hotels International",
        "logoUrl": "https://static.swapcard.com/public/images/000fb39570764a34b22b860012d1a87e.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMg==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMzg1NTA=",
        "name": "Story Hospitality",
        "logoUrl": "https://static.swapcard.com/public/images/d29f01bee2c14a10811766f666965454.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQ0MQ==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyMzg2Mjk=",
        "name": "Italia Hospitality",
        "logoUrl": "https://static.swapcard.com/public/images/b305e97309fd45e5ac1a85f88c01cac8.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQ0MQ==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyNDE4NDQ=",
        "name": "The First Group Hospitality",
        "logoUrl": "https://static.swapcard.com/public/images/63353414bfb0477e947e6c53a868e56d.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMQ==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyNDkxODM=",
        "name": "The Ascott Limited",
        "logoUrl": "https://static.swapcard.com/public/images/345454b730df4342a3a49403cb7f29f4.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQ0MQ==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyODE5Mzk=",
        "name": "Minor Hotels",
        "logoUrl": "https://static.swapcard.com/public/images/042bbabdbc08498e8d7977962df9d15c.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMQ==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyODE5OTM=",
        "name": "WhiteWater",
        "logoUrl": "https://static.swapcard.com/public/images/f6696f96ed274e9481a83b534c8946e2.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMg==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIyOTEyMjI=",
        "name": "Jabal Omar Development Compamy",
        "logoUrl": "https://static.swapcard.com/public/images/97838b5501cc4207bb5719fb39389969.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQ0Mg==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzMjA1NDg=",
        "name": "The Indian Hotels Company Limited",
        "logoUrl": "https://static.swapcard.com/public/images/fc52372554cb4301a71f397840ebe0eb.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMQ==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzMzM2Nzk=",
        "name": "Sommet Education",
        "logoUrl": "https://static.swapcard.com/public/images/3d12d85797754fa7be4086b88a984569.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMQ==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzMzc1MDY=",
        "name": "Radisson Hotel Group",
        "logoUrl": "https://static.swapcard.com/public/images/3255015905e04484aab814f904b2be98.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQ0Mg==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzNDAwNjU=",
        "name": "Accor",
        "logoUrl": "https://static.swapcard.com/public/images/7b6a970aa62046ada85af31ffa760243.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMQ==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzNDk5MDc=",
        "name": "DAR Engineering",
        "logoUrl": "https://static.swapcard.com/public/images/ef33a8703a8144c7a0d55da8980bafe0.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMg==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzNTEwNzk=",
        "name": "iReserved",
        "logoUrl": "https://static.swapcard.com/public/images/cbdfdd6502784adfab95bbff006da41a.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMg==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzNTk3NjM=",
        "name": "Gary Greene Design",
        "logoUrl": "https://static.swapcard.com/public/images/89f53560279b4a4c9a7e9c18df6444d4.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMQ==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzNjAzMzk=",
        "name": "AIRE",
        "logoUrl": "https://static.swapcard.com/public/images/6153982b583d4282b235e3c304596c3a.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMg==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODE3ODM=",
        "name": "Kofisi",
        "logoUrl": "https://static.swapcard.com/public/images/1f14a5e0ec8b4ebd82d67facf4393579.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMQ==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODMxODc=",
        "name": "Rotana Hotels and Resorts",
        "logoUrl": "https://static.swapcard.com/public/images/509f8a7dcf094ebf9f9ad42481e5f9fe.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQ0MQ==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzOTI3MTM=",
        "name": "China - Chongqing District Pavilion",
        "logoUrl": "https://static.swapcard.com/public/images/113471bcf1f6439db76bb1c770d6cc10.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQ0Mg==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzOTI3MTc=",
        "name": "Safir Hotels & Resorts",
        "logoUrl": "https://static.swapcard.com/public/images/69b6a59811a84bcc812bd6b80190af48.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMg==",
                "value": "exhibitors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Exhibitors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzOTcwNDI=",
        "name": "H World International",
        "logoUrl": "https://static.swapcard.com/public/images/70f7747290434ee2912b1bc581a9981b.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMQ==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MDI4NjU=",
        "name": "The Torch Hospitality",
        "logoUrl": "https://static.swapcard.com/public/images/2b6a56bf90fc493facc3db1a10182ea7.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQ0MQ==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Sponsor"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MDYzODI=",
        "name": "Blacklane",
        "logoUrl": "https://static.swapcard.com/public/images/d669fcaccac443fb899e9ab0dec56fc1.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMQ==",
                "value": "sponsors",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Sponsors"
                    }
                ]
            }
        ]
    }
]

const africaPartners2026 = [
    {
        "id": "RXhoaWJpdG9yXzIzNTEwMTc=",
        "name": "Club Med",
        "logoUrl": "https://static.swapcard.com/public/images/94523ce7fd344bfa9978a0551fbaa56a.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjM5NDE1NA==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzNTEwMTg=",
        "name": "IHG",
        "logoUrl": "https://static.swapcard.com/public/images/8dcad373d71b452a845a943dbba824e1.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjM5NDE1NA==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzNTEwMTk=",
        "name": "Radisson Hotel Group",
        "logoUrl": "https://static.swapcard.com/public/images/b4c15c727dd4455282d40731956c03c7.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjM5NDE1NA==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzNTEwMjc=",
        "name": "The First Group Hospitality",
        "logoUrl": "https://static.swapcard.com/public/images/44d9b23ceccc4b7a8615e97fca341a56.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzIzODA3Mjc=",
        "name": "Accor",
        "logoUrl": "https://static.swapcard.com/public/images/da3bd47978f243f19aef6c4cb8ab078c.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjM5NDE1NA==",
                "value": "strategic-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Strategic Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjA5MjQ=",
        "name": "Clique Ltd",
        "logoUrl": "https://static.swapcard.com/public/images/62fdc685f0ac4d118939995f1aefb1fc.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjY5NzQ=",
        "name": "Westmont Hospitality Group",
        "logoUrl": "https://static.swapcard.com/public/images/31ec17002f804e2ea27ac2bb98da0edb.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTAzNDczOQ==",
                "value": "Host Sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Host Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjY5Nzc=",
        "name": "ACT",
        "logoUrl": "https://static.swapcard.com/public/images/c185963a492e4d88ac0fe3c675b17d71.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwMDk=",
        "name": "CityBlue Hotels",
        "logoUrl": "https://static.swapcard.com/public/images/80ebdec2e1e84f2da995d0568560a8de.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwMTA=",
        "name": "COMPAGNIE HOTELIERE ET IMMOBILIERE DU CONGO (CHIC)",
        "logoUrl": "https://static.swapcard.com/public/images/8cca510d73c84298ad51919cb4e1c940.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwMTQ=",
        "name": "Hansgrohe",
        "logoUrl": "https://static.swapcard.com/public/images/7a404902adaa446c8b44f8b677958207.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwMTU=",
        "name": "KOFISI",
        "logoUrl": "https://static.swapcard.com/public/images/97013a2e8bf34edaae455872e6777acc.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwMTY=",
        "name": "QUO",
        "logoUrl": "https://static.swapcard.com/public/images/6cb17ebbbf0147688e5a2d01894aecff.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwMjE=",
        "name": "Aleph Hospitality",
        "logoUrl": "https://static.swapcard.com/public/images/6750646b33cc41f99cc6bf5c147f950b.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwMjI=",
        "name": "Gary Greene Design",
        "logoUrl": "https://static.swapcard.com/public/images/6b1644110dca41cb98aee9cbac1b5de0.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwMjM=",
        "name": "Knight Frank",
        "logoUrl": "https://static.swapcard.com/public/images/67a90ff6242246c39c14ffa31e137a96.webp",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwMjQ=",
        "name": "STR",
        "logoUrl": "https://static.swapcard.com/public/images/e8257ae6975a4ea891e3b0c8cbe95236.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwMjY=",
        "name": "Education Partner",
        "logoUrl": "https://static.swapcard.com/public/images/6ef5b5d205f54bf7839a848bcb5cfc37.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTk2MzQ4OQ==",
                "value": "education-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Education Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwMzI=",
        "name": "AIRE",
        "logoUrl": "https://static.swapcard.com/public/images/877304e2d69a416f9fce115ec0a7c85d.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwMzM=",
        "name": "Develop Hotels Inc",
        "logoUrl": "https://static.swapcard.com/public/images/7db52b778773412d8018e5f66fc54189.webp",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MTMyNw==",
                "value": "event-ambassador",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Event Ambassadors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwMzQ=",
        "name": "Hotel Partners Africa",
        "logoUrl": "https://static.swapcard.com/public/images/022b1c424203481f9299260392391177.webp",
        "fields": []
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwMzU=",
        "name": "PKF hospitality group",
        "logoUrl": "https://static.swapcard.com/public/images/fca27dbda32b4bc2b47896fcef92ff70.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MTMyNw==",
                "value": "event-ambassador",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Event Ambassadors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwMzY=",
        "name": "Voltere by Egis",
        "logoUrl": "https://static.swapcard.com/public/images/ef438807087448828b253cdb7a59fc4b.webp",
        "fields": []
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwMzc=",
        "name": "W Hospitality Group",
        "logoUrl": "https://static.swapcard.com/public/images/cbd214340a934941979a47032e5d35fc.webp",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MTMyNw==",
                "value": "event-ambassador",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Event Ambassadors"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwMzg=",
        "name": "Kenya Airways",
        "logoUrl": "https://static.swapcard.com/public/images/5dc9f4f1b86a4752bcda3dd076f6813c.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMzkxMjA4NA==",
                "value": "official-carriers",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Official Carrier"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwNDQ=",
        "name": "APO Group",
        "logoUrl": "https://static.swapcard.com/public/images/a392171ee6224b4ba686a1eb79576500.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MTUxNQ==",
                "value": "pan-africa-publication-relations-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Pan Africa Publication Relations Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwNDU=",
        "name": "Kleber Group",
        "logoUrl": "https://static.swapcard.com/public/images/804f21a62f924d5fb6c2f3cfb85ed82f.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MTUxNQ==",
                "value": "pan-africa-publication-relations-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Pan Africa Publication Relations Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwNjg=",
        "name": "Trianum Hospitality",
        "logoUrl": "https://static.swapcard.com/public/images/66d776661a1c4931866e2cc22c8ddcc8.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTk2MzUxMA==",
                "value": "networking-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Networking Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwNzU=",
        "name": "Uganda Tourism Board",
        "logoUrl": "https://static.swapcard.com/public/images/379565ba8c7842c8bb7461b1406c3238.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MDgyNw==",
                "value": "headline-sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Headline Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwOTE=",
        "name": "Wyndham Hotels & Resorts",
        "logoUrl": "https://static.swapcard.com/public/images/e5cce1024ec74df18016a7d1bc86bd48.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcwOTk=",
        "name": "Planet Food",
        "logoUrl": "https://static.swapcard.com/public/images/edcab36d15dc4ba683d2c7e9943706d7.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTk2MzUxMA==",
                "value": "networking-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Networking Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcxMjQ=",
        "name": "Africa Hotel Report",
        "logoUrl": "https://static.swapcard.com/public/images/7e5ca6ba7b9a47ddba8fc05def7013e8.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "value": "media-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcxMzQ=",
        "name": "African Travel Times",
        "logoUrl": "https://static.swapcard.com/public/images/1eaf6020d3844956bf53c5ac3c26ff18.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "value": "media-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcxNTA=",
        "name": "The Afritraveller",
        "logoUrl": "https://static.swapcard.com/public/images/b18a3d753e6a493f8bc59c6cc53ba6e1.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "value": "media-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcxNTE=",
        "name": "Breaking Travel News",
        "logoUrl": "https://static.swapcard.com/public/images/eb34fffe429d4067bfa28f3dec168e55.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "value": "media-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcxNTM=",
        "name": "Go Places Digital",
        "logoUrl": "https://static.swapcard.com/public/images/e3fa3ac36373418f9884c4e2f1f8bb9a.webp",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "value": "media-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcxNTQ=",
        "name": "Hozpitality.com",
        "logoUrl": "https://static.swapcard.com/public/images/eb364f2ad64d4c439c790f8838fcd55d.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "value": "media-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcxNTU=",
        "name": "Pan African Voice",
        "logoUrl": "https://static.swapcard.com/public/images/604170f726cd4aa1945cd3ff4f0b01b8.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "value": "media-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcxNTY=",
        "name": "Travel & Tour World",
        "logoUrl": "https://static.swapcard.com/public/images/fd1b9473a5834bd391d85b63a6ff6a8d.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "value": "media-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcxNTc=",
        "name": "Travelscope",
        "logoUrl": "https://static.swapcard.com/public/images/3119fb948fa84ac3b08b67b704043e31.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "value": "media-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcxNTg=",
        "name": "Voyages Afriq",
        "logoUrl": "https://static.swapcard.com/public/images/3fc61900d9d641b285210457a1e70437.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "value": "media-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcxNTk=",
        "name": "FEDHASA",
        "logoUrl": "https://static.swapcard.com/public/images/071b6e1550df402582c4cde2dd29d530.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "value": "supporter",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Supporters"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcxODk=",
        "name": "Kenya Association of Hotelkeepers",
        "logoUrl": "https://static.swapcard.com/public/images/96684536b22746f7929bcddfed3f6e38.jpeg",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "value": "supporter",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Supporters"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcxOTA=",
        "name": "SADC Business Council",
        "logoUrl": "https://static.swapcard.com/public/images/2fa0fabee40e49a7a393b12255c44a23.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "value": "supporter",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Supporters"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MjcxOTE=",
        "name": "Uganda Hotel Owners Association",
        "logoUrl": "https://static.swapcard.com/public/images/919cbdc45ec948f5b282c5e8d00fb18a.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "value": "supporter",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Supporters"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0Mjg3NDI=",
        "name": "LMR - Choice Hotels",
        "logoUrl": "https://static.swapcard.com/public/images/8af97491e19946d696b797bf8675f9cd.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0Mjk0NjE=",
        "name": "TUKO",
        "logoUrl": "https://static.swapcard.com/public/images/a3f00835416f4b4791ac24aa69ca45c2.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "value": "media-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MzA3NzU=",
        "name": "MIC Global Risks",
        "logoUrl": "https://static.swapcard.com/public/images/7895d18ec4ac4130a39126b22199a619.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTk2MzUxMA==",
                "value": "networking-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Networking Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MzMyNTM=",
        "name": "It's a Penalty",
        "logoUrl": "https://static.swapcard.com/public/images/e8b2c50e5c624b9692e9eba22160286d.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "value": "supporter",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Supporters"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MzMyNTY=",
        "name": "Raising Futures Kenya",
        "logoUrl": "https://static.swapcard.com/public/images/8b75aac35ca1456582377ae031f8fb9a.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8zMDA0MTcxNw==",
                "value": "charity-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Charity Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0MzcyMDI=",
        "name": "Africa GCC Council",
        "logoUrl": "https://static.swapcard.com/public/images/33b2c598b77149789261baaf7f12b826.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODgzNg==",
                "value": "supporter",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Supporters"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNzc4OTQyMw==",
                "value": "supporters",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzgzMTQ3MQ==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Supporters"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0Mzc4NDA=",
        "name": "Ozti",
        "logoUrl": "https://static.swapcard.com/public/images/59a662f822ed46788cac0ea1f95b6947.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yOTk2MzUxMA==",
                "value": "networking-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Networking Partner"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0Mzc4NTQ=",
        "name": "Kora",
        "logoUrl": "https://static.swapcard.com/public/images/350356c9e4cc4770bb66456fc18395bc.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNzM1MDg0OA==",
                "value": "sponsor",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Partners"
                    }
                ]
            }
        ]
    },
    {
        "id": "RXhoaWJpdG9yXzI0Mzg2NjE=",
        "name": "Travel News East Africa",
        "logoUrl": "https://static.swapcard.com/public/images/b08f0198f4ee4fbb83a69e0ba4383a45.png",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTE4ODg3Mg==",
                "value": "media-partner",
                "definition": {
                    "id": "RmllbGREZWZpbml0aW9uXzI5NjgyNg==",
                    "name": "Type"
                },
                "translations": [
                    {
                        "value": "Media Partners"
                    }
                ]
            }
        ]
    }
]



export const partners = [...worldPartners2026, ...saudiPartners2026, ...africaPartners2026]